


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';

@Component
export default class CashflowTable extends Vue {
  @Prop() readonly cashflow!: any;
  @Prop() readonly currentLanguage!: any;

  // tslint:disable:max-line-length
  rows: any = [
    { text: this.currentLanguage === 'en' ? 'Operating cash flow' : Vue.prototype.$t('Operativt kassaflöde'), values: [], styles: ['section-title'] },
    {
      text: this.currentLanguage === 'en' ? 'Earning Before Interest and Tax' : Vue.prototype.$t('Rörelseresultat'),
      values: ['OperatingResult'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Disclosure of non-cash activities' : Vue.prototype.$t('Justering för ej likviditetspåverkande poster'),
      values: ['Adjustment'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Disclosure of Financial posts' : Vue.prototype.$t('Justering för Finansiella poster'),
      values: ['TotFinInvestments'],
      styles: ['sub-item'],
    },
    { text: this.currentLanguage === 'en' ? 'Tax' : Vue.prototype.$t('Årets skatt'), values: ['Tax'], styles: ['sub-item'] },
    {
      text: this.currentLanguage === 'en' ? 'Operating cash flow' : Vue.prototype.$t('Kassaflöde från den operativa verksamheten'),
      values: ['OperatingCashflow'],
      styles: ['major_sum'],
    },

    { text: this.currentLanguage === 'en' ? 'Working capital' : Vue.prototype.$t('Rörelsekapital'), values: [], styles: ['section-title'] },
    {
      text: this.currentLanguage === 'en' ? 'Increase(-)/Decrease(+) Inventory' : Vue.prototype.$t('Ökning(-)/Minskning(+) av Varulager'),
      values: ['InventoriesDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Increase(-)/Decrease(+) Accounts receivable' : Vue.prototype.$t('Ökning(-)/Minskning(+) av Kundfordringar'),
      values: ['AccountReceivableTradeDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Increase(-)/Decrease(+) Other receivables' : Vue.prototype.$t('Ökning(-)/Minskning(+) av Övriga kortfristiga fordringar'),
      values: ['OtherAccReceiveDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Decrease(-)/Increase(+) Accounts payable' : Vue.prototype.$t('Minskning(-)/Ökning(+) av Leverantörsskulder'),
      values: ['AccPayTradeDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Decrease(-)/Increase(+) Other short term debts' : Vue.prototype.$t('Minskning(-)/Ökning(+) av Övriga kortfristiga skulder'),
      values: ['OtherCurrentLiabilitiesDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Cash flow from change in working capital' : Vue.prototype.$t('Kassaflöde från förändring av rörelsekapital'),
      values: ['WorkingCaptialCashflow'],
      styles: ['major_sum'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Cash from operating activities' : Vue.prototype.$t('Summa kassaflöde från den löpande verksamheten'),
      values: ['OperatingCashflow', 'WorkingCaptialCashflow'],
      styles: ['major_major_sum'],
    },

    { text: this.currentLanguage === 'en' ? 'Investments' : Vue.prototype.$t('Investeringar'), values: [], styles: ['section-title'] },
    {
      text: this.currentLanguage === 'en' ? 'Increase(-)/Decrease(+) Fixed assets' : Vue.prototype.$t('Ökning(-)/Minskning(+) av Anläggningstillgångar'),
      values: ['TotFixAssetsDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Disclosure of depreciations and write-downs' : Vue.prototype.$t('Justering för Av- och nedskrivningar'),
      values: ['DeprAndWriteDowns'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Increase(-)/Decrease(+) Short investments' : Vue.prototype.$t('Ökning(-)/Minskning(+) av Kortfristiga placeringar'),
      values: ['ShortInvestmentsDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Cashflow from investing activities' : Vue.prototype.$t('Kassaflöde från investeringar'),
      values: ['InvestmentsCashflow'],
      styles: ['major_sum'],
    },

    { text: this.currentLanguage === 'en' ? 'Financing' : Vue.prototype.$t('Finansiering'), values: [], styles: ['section-title'] },
    {
      text: this.currentLanguage === 'en' ? 'Withdrawal(-)/Deposit(+) from owners' : Vue.prototype.$t('Uttag(-)/Insättning(+) av ägarkapital'),
      values: ['EquityWithoutNetProfitDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Disclosure of depreciations and write-downs' : Vue.prototype.$t('Justering för av- och nedskrivningar'),
      values: ['SubscribedCapitalUnpaidDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Decrease(-)/Increase(+) Interest-bearing liabilities' : Vue.prototype.$t('Minskning(-)/Ökning(+) av Räntebärande skulder'),
      values: ['InterestLiabilitiesDelta'],
      styles: ['sub-item'],
    },
    {
      text: this.currentLanguage === 'en' ? 'Cashflow from financing' : Vue.prototype.$t('Kassaflöde från finansiering'),
      values: ['FinancingCashflow'],
      styles: ['major_sum'],
    },

    {
      text: this.currentLanguage === 'en' ? 'Other adjustment for non-cash activities' : Vue.prototype.$t('Övriga justeringar för ej likviditetspåverkande poster'),
      values: ['CashFlowError'],
      styles: ['minor_sum', 'red'],
    },
    { text: this.currentLanguage === 'en' ? 'Total cash flow' : Vue.prototype.$t('Årets kassaflöde'), values: ['CashFlow'], styles: ['major_major_sum'] },
  ];
  cols: any = [];
  hoveredCol: number = -1;
  hoveredRow: number = -1;

  getColsClass() {
    return 'cols' + this.cols.length;
  }

  getHovered(col: number, row: number) {
    if (col === this.hoveredCol && row === this.hoveredRow) {
      return 'hovered-exact';
    } else if (col === this.hoveredCol || row === this.hoveredRow) {
      return 'hovered';
    }
    return '';
  }

  mouseOver(col: number, row: number) {
    this.hoveredCol = col;
    this.hoveredRow = row;
  }

  mouseOut() {
    this.hoveredCol = -1;
    this.hoveredRow = -1;
  }

  show(row: any): boolean {
    const name = row.values[0];
    if (name !== 'CashFlowError' && name !== 'SubscribedCapitalUnpaidDelta') {
      return true;
    }
    for (let i = 0; i < this.cols.length; i++) {
      if (this.val(i, row) !== '' && this.val(i, row) !== '0') {
        return true;
      }
    }
    return false;
  }

  style(row: any): string {
    const name = row.values[0];
    if (name !== 'CashFlowError') {
      return '';
    }
    for (let i = 0; i < this.cols.length; i++) {
      if (this.val(i, row) !== '') {
        return 'red';
      }
    }
    return '';
  }

  val(i: number, row: any) {
    const name = row.values[0];
    if (name === undefined) {
      return '';
    }
    if (name === 'CashFlowError' && this.cashflow.sheets[i][name] === 0) {
      return '';
    }
    if (name === 'Error') {
      return (Vue as any).options.filters.D2(this.cashflow.sheets[i][name]);
    } else {
      let x = this.cashflow.sheets[i][name];
      for (let idx = 1; idx < row.values.length; idx++) {
        x += this.cashflow.sheets[i][row.values[idx]];
      }
      return (Vue as any).options.filters.D0(x);
    }
  }

  title(i: number) {
    return (
      this.cashflow.sheets[i].DATE_TO.substr(0, 7) +
      ' (' +
      this.cashflow.sheets[i].MONTHS + ' ' +
      Vue.prototype.$t('mån') + ')'
    );
  }

  get hasData(): boolean {
    return this.cols.length > 0;
  }

  @Watch('cashflow', { immediate: true, deep: true })
  onCashflowChanged(newVal: any, oldVal: any) {
    this.cols.splice(0, this.cols.length);
    if (this.cashflow !== undefined) {
      for (let i = 0; i < this.cashflow.count; i++) {
        this.cols.push(i);
      }
    }
  }
}
